import vec4_scale from"gl-vec4/scale";import vec4_transformMat4 from"gl-vec4/transformMat4";export function createMat4(){return[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]}export function transformVector(matrix,vector){var result=vec4_transformMat4([],vector,matrix);return vec4_scale(result,result,1/result[3]),result}export function mod(value,divisor){var modulus=value%divisor;return 0>modulus?divisor+modulus:modulus}export function lerp(start,end,step){return step*end+(1-step)*start}
//# sourceMappingURL=math-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/viewport-mercator-project/dist/esm/math-utils.js
// module id = 83
// module chunks = 0